import React, { useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
  Box,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Checkbox from '@mui/material/Checkbox';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const AddInventoryModal = () => {
  const [open, setOpen] = useState(false);
  const [type] = useState(["Ургамал", "Гоёл", "Нэмэлт"]);
  const [delived, setDelived] = useState(false);
  const [productData, setProductData] = useState({
    item_name: "",
    price: "",
    item_type: "",
    itemImages: [],
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setProductData({
      item_name: "",
      price: "",
      item_type: "",
      itemImages: [],
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData({
      ...productData,
      [name]: value,
    });
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setProductData({
      ...productData,
      itemImages: files,
    });
  };

  const handleSave = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("item_name", productData.item_name);
    formData.append("price", productData.price);
    formData.append("item_type", productData.item_type);
    formData.append("delived", delived);
    productData.itemImages.forEach((image, index) => {
      formData.append(`itemImages[${index}]`, image);
    });

    axios
      .post("https://tsetsegtuw.templateapi.xyz/item/", formData)
      .then((response) => {
        console.log("Product saved successfully:", response.data);
        handleClose();
      })
      .catch((error) => {
        console.error("Error saving product:", error);
      });
  };

  return (
    <div>
      <Button variant="contained" color="primary" onClick={handleClickOpen}>
        Бараа нэмэх
      </Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Бараа нэмэх</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Барааны нэр"
            type="text"
            name="item_name"
            fullWidth
            value={productData.item_name}
            onChange={handleChange}
          />

          <TextField
            margin="dense"
            label="Үнэ "
            type="number"
            name="price"
            fullWidth
            value={productData.price}
            onChange={handleChange}
          />
          <FormControl fullWidth margin="dense">
            <InputLabel>Төрөл</InputLabel>
            <Select
              name="item_type"
              value={productData.item_type}
              onChange={handleChange}
            >
              {type.map((type, index) => (
                <MenuItem key={index} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <div className="flex justify-start items-center">
            <Checkbox onClick={() => setDelived(!delived)} value={delived} {...label} />
            <p>{delived ? 'Хүргэлттэй' : 'Хүргэлтгүй'}</p>
          </div>
          <Box mt={2}>
            <Typography variant="subtitle1">Зураг нэмэх</Typography>
            <Button
              variant="contained"
              component="label"
              startIcon={<UploadFileIcon />}
            >
              Зураг нэмэх
              <input
                type="file"
                hidden
                typeof="image/*"
                multiple
                onChange={handleImageUpload}
              />
            </Button>
            {productData.itemImages.length > 0 && (
              <Box mt={1}>
                {productData.itemImages.map((image, index) => (
                  <Typography key={index} variant="body2">
                    {image.name}
                  </Typography>
                ))}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              padding: "15px",
            }}
          >
            <Button variant="contained" onClick={handleSave} color="primary">
              Нэмэх
            </Button>
            <Button variant="contained" color="error" onClick={handleClose}>
              хаах
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddInventoryModal;
